import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Format status colors for badges
export function getStatusVariant(status: string) {
  const statusLower = status.toLowerCase();
  
  if (statusLower === 'ready') return 'status-ready';
  if (statusLower === 'in pilot') return 'status-pilot';
  if (statusLower === 'development') return 'status-development';
  
  return 'status-ready'; // default
}

// Animation delay helper
export function getAnimationDelay(index: number, baseDelay = 100): string {
  return `${index * baseDelay}ms`;
}

// Platform icon mapping helper
export function getPlatformIconColor(platformName: string): string {
  const name = platformName.toLowerCase();
  
  if (name.includes('skytab pos') || name.includes('venue')) {
    return 'text-orange-500';
  }
  if (name.includes('solo')) {
    return 'text-green-500';
  }
  if (name.includes('acquiring')) {
    return 'text-blue-500';
  }
  if (name.includes('lbm') || name.includes('hospitality')) {
    return 'text-purple-500';
  }
  if (name.includes('marketplace') || name.includes('integrations')) {
    return 'text-pink-500';
  }
  
  return 'text-primary';
}

// Generate random position for animated elements
export function getRandomPosition() {
  return {
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
  };
}

// Debounce utility
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout;
  
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

// Format platform name for display
export function formatPlatformName(name: string): string {
  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}